module.exports = __webpack_public_path__ + "static/media/image2.b47534de.jpg";